/**
 * 预计出货订单
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React from 'react';
import {Badge, Checkbox, Space, Spin, Tooltip,} from "antd";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import Lang from "@/components/Lang/Lang";
import AuthBtn from "@components/HoverIcon/AuthBtn";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import {getRandomString} from "@utils/utils";
import config from "@config/config";
import dayjs from 'dayjs';
import Locale from "@utils/locale";
import { toFixedWithCommas} from "@utils/number-util";
import IconDirectPo from "@components/Icon/IconDirectPo/IconDirectPo";//直达图标
import "./List.less";

class CustomsCoding extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            isCheckPreLoadDate:'',
            searchFormOptions:[
                {
                    name:'transitCityIds',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'所有仓库',
                    cnPlaceholderId:'SuoYouCangKu',
                    type:'WarehouseSelect',
                },
                {
                    name:'keyword',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'请输入集柜单号或客户编号',
                    cnPlaceholderId:'QingShuRuJiGuiDanHaoHuoKeHuBianHao',
                    width:400,
                },
            ],
            columns:[
                {
                    cnTitle: '集柜单号',
                    cnTitleId: 'JiGuiDanHao',
                    dataIndex: 'containerCode',
                    width:150,
                    render:  (text, record, index) => (
                        <span className={"fw_700 black89"}>
                            {record.noCertificateSplit==1?<Tooltip title={__getServerLanguage('ZhongGuoZhiFaDingDan')}><span className={"ml_4"}>
                                            <IconDirectPo size={18}></IconDirectPo>
                                        </span>
                            </Tooltip>:null}
                            {text}</span>
                    )
                },
                {
                    cnTitle: '订单数',
                    cnTitleId: 'DingDanShu',
                    dataIndex: 'orderCount',
                },
                {
                    cnTitle: '商品信息',
                    dataIndex: 'poCreateTime',
                    cnTitleId: 'ShangPinXinXi',
                    render:  (text, record, index) => (
                            <span>{record.skuCount}{Lang({id:'Kuan', default:'款'})}, {record.quantity}{Lang({id: 'Xiang', default: '箱'})}</span>
                    )
                },
                {
                    cnTitle: '总体积m³',
                    dataIndex: 'totalVolume',
                    cnTitleId: 'ZongTiJiM3',
                    render: (totalVolume, record) => <span className="content-text">{toFixedWithCommas(totalVolume, 3) || "-"}</span> //{" "}m³
                },
                {
                    cnTitle: '目的仓库',
                    cnTitleId: 'MuDiCangKu',
                    dataIndex: 'transitCityName',
                },
                {
                    cnTitle: '预计出货时间',
                    dataIndex: 'preLoadDate',
                    cnTitleId: 'YuJiChuHuoShiJian',
                    render: (preLoadDate, record) =>{
                        return (<div>{record.oldPreLoadDate?<Tooltip title={record.oldPreLoadDate?Lang({id: 'ShangYiCi',default:'上一次'})+'：'+dayjs(record.oldPreLoadDate).format('YYYY-MM-DD'):'-'}>
                            <Badge status="error" /><span className={"ml_4"}>{preLoadDate?dayjs(preLoadDate).format('YYYY-MM-DD'):'-'}</span>
                        </Tooltip>:(preLoadDate?dayjs(preLoadDate).format('YYYY-MM-DD'):'-')}</div>)
                    }
                },
                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 100,
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => (<Space>
                        <AuthBtn icon={"ri-file-excel-2-line"} tips = {Lang({id:"YuZhuangXiangDan",default:"预装箱单"})}
                                       onClick={()=>this.getPrintModel(record)}/>
                        <AuthBtn icon={"ri-article-line"} tips = {Lang({id:"XiangQing",default:"详情"})}
                                       linkTo={{
                                           pathname: '/shipperManagement/estimatedShippingOrder/detail',
                                           search: `?${record.containerId}`,
                                       }
                                       }/>
                    </Space>)},
            ],
        }
    }
    /** 打开预装箱单 */
    getPrintModel(record){
        const currLocaleLang = Locale.current();
        const url =  config.servers[config.environment].exportApi +'/data/bpms/jreport/con_ddp/pre_load_print?template='+'ConDdpPrdLoadReport_'+currLocaleLang
            +'&token='+getRandomString(15)+'&pwd='+getRandomString(8)+'&langCode='+currLocaleLang+'&timestamps='+new Date().getTime()+'&lang='+currLocaleLang+'&containerId='+record.containerId+'&isCheck=0&%24isGetHttpConfig=true';
        window.open(url);
    }

    /**
     * 勾选 待确认随车单
     * */
    onChangeSelect(e){
        const {checked}= e.target;
        this.setState({
            isCheckPreLoadDate:checked?1:''
        },()=> {
            this.onPageTemplateTableChild.handleFetch();
        })
    }
    onRefTabOne = (ref) =>  this.onPageTemplateTableChild = ref;
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    render(){
        const { loading,searchFormOptions,columns,isCheckPreLoadDate} = this.state;
        const currPageName = Lang({id: "YuChuHuoJiGui",default: "预出货集柜"});
        //待确认随车单
        const setLeftOne =(<div className={'ml_12'} style={{lineHeight: "32px"}}>
            <Checkbox onChange={(e)=>this.onChangeSelect(e)}>{Lang({id:'ChuHuoShiJianiYouGaiBian',default:'出货时间有改变'})}</Checkbox>
        </div>);
        return (<Spin tip='loading' spinning={loading}>
                <CommonBreadcrumb list={[{ name:currPageName}]}></CommonBreadcrumb>
                <div className={'progressTrackingList'}>
                    <div className={'title fw_700 font_18'}>{currPageName}</div>
                    <AutoFetchTable columns={columns}
                                    onRef={this.onRefTabOne}
                                    flagShowReset={false}
                                    topSearchLeftRight={setLeftOne}
                                    precondition={{type:1,isCheckPreLoadDate:isCheckPreLoadDate}} // 列表类型 	1: 预装列表 2:已出货列表
                                    searchFormOptions={searchFormOptions}
                                    rowKey={'containerId'}
                                    fetchApi={'/service/mg/container/list'} />
                </div>
            </Spin>

        )
    }
}

export default CustomsCoding;
